/**
 * 房源管理路由
 */
export default {
  path: '/userOrder',
  name: 'userOrder',
  redirect: '/userOrder/waitOrder',
  component: () => import('../views/userOrderList/index.vue'),
  meta: {
    headerTitle: '订单',
    icon: 'ab-iconfont ab-icon-order-setting',
    auth: 1007
  },
  children: [
    {
      path: 'waitOrder',
      name: 'waitOrder',
      redirect: '/userOrder/waitOrder/waitOrderList',
      component: () => import('../views/userOrderList/index.vue'),
      meta: {
        headerTitle: '待分房',
        icon: 'house',
        hideChildren: 'house.hotelInfo.hotelType',
        hideValue: [0, 2],
        count: 'order.orderNumbers.notHasAssignOrderNum'
      },
      children: [
        {
          path: 'waitOrderList',
          name: 'waitOrderList',
          // redirect: '/house/houseType/houseTypeManage/houseTypeList',
          component: () => import('../views/userOrderList/index.vue'),
          meta: {
            headerTitle: '待分房订单'
          }
        },
        {
          path: 'waitOrderCheckIn',
          name: 'waitOrderCheckIn',
          component: () => import('../views/userOrderList/index.vue'),
          meta: {
            headerTitle: '登记入住'
          }
        }
      ]
    },
    {
      path: 'todayCheckIn',
      name: 'todayCheckIn',
      component: () => import('../views/userOrderList/index.vue'),
      meta: {
        headerTitle: '今日入住',
        icon: 'checkin',
        count: 'order.orderNumbers.toDayCheckInOrderNum'
      }
    },
    {
      path: 'todayCheckOut',
      name: 'todayCheckOut',
      component: () => import('../views/userOrderList/index.vue'),
      meta: {
        headerTitle: '今日离店',
        icon: 'checkout',
        count: 'order.orderNumbers.toDayCheckOutOrderNum'
      }
    },
    {
      path: 'allOrder',
      name: 'allOrder',
      component: () => import('../views/userOrderList/index.vue'),
      meta: {
        headerTitle: '全部订单',
        icon: 'allorder',
        count: 'order.orderNumbers.allOrdersNum'
      }
    }
  ]
}
